import { IconWrapper } from '../runtime';
export default IconWrapper('inline-code', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M3.55033 4.09979L1.38682 7.84987C1.3333 7.94265 1.3333 8.05693 1.38682 8.14971L3.55033 11.8998M6.00033 14.2797L9.36498 1.72266M12.4503 11.8996L14.6138 8.14951C14.6674 8.05673 14.6674 7.94246 14.6138 7.84968L12.4503 4.09959",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});